import { InboxStore } from "@/services/stores/types";

export const selectInboxStore = ({
  activeInboxItem,
  setActiveInboxItem,
}: InboxStore) => ({
  activeInboxItem,
  setActiveInboxItem,
});

export const selectActiveInboxData = ({ activeInboxItem }: InboxStore) => ({
  activeInboxItem,
});
